export const CANDIDATE_OFFER_ACCEPT_CONTEXT = 'CANDIDATE_OFFER_ACCEPT_CONTEXT';
